@use "~theme/typography";
@use "~theme/breakpoints";

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  @include breakpoints.desktop {
    position: relative;
    display: block;
    margin-bottom: 0;
  }
}

.modal {
  box-sizing: border-box;
  padding: 16px 12px;
  width: min(100%, 518px);
  max-width: 518px;

  @include breakpoints.mobile-large {
    padding: 16px;
  }
}

.modalTitle {
  @include typography.heading3;
  margin: 0;
  text-align: center;
  max-width: 100%;
  overflow-wrap: anywhere;

  @include breakpoints.desktop {
    margin: 16px auto;
    max-width: 374px;
  }
}

.modalButtons {
  display: flex;

  button {
    width: 100%;
  }
}

.modalCaption {
  @include typography.caption;
}

.modalEmbeddedDocument {
  @include typography.body;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 240px;
  border: 1px solid var(--blue-01-at-30);
  padding: 20px 24px;
  border-radius: 2px;
  max-width: 100%;
  overscroll-behavior: contain;
  overflow-wrap: anywhere;
  word-break: break-word;

  @include breakpoints.mobile-large {
    padding: 20px 24px;
  }

  * {
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

.printButtonContainer {
  align-self: flex-end;

  @include breakpoints.desktop {
    position: absolute;
    right: 0;
    bottom: -12px;
  }
}
